export interface ITask<T> {
    process(arg: T): Promise<T>;
}

export abstract class AbstractTask<T> implements ITask<T> {
    abstract process(arg: T): Promise<T>;
}
